import { Box, Typography } from "@mui/material";

export const Footer = () => {
  return (
    <Box
      sx={{
        bgcolor: "hsl(150, 70%, 18%)",
        color: "white",
        py: 4,
        textAlign: "center",
      }}
    >
      <Typography sx={{ opacity: 0.8 }}>
        🎄 Φτιαγμένο με αγάπη για τις γιορτές 🎁
      </Typography>
    </Box>
  );
};
